import React, { useState } from "react";
import { Button, Modal, ModalHeader, ModalBody, ModalFooter, FormGroup, Label, Input } from "reactstrap";
import PropTypes from "prop-types";

const ModalUploadR365File = ({ onJoinedExport, closeModal, isModalOpen }) => {
  const [file, setFile] = useState(null);

  const handleChangeFile = (event) => {
    setFile(event.target.files[0]);
  };

  return (
    <Modal isOpen={isModalOpen} toggle={closeModal} className={"modal-warning modal-logut"}>
      <ModalHeader toggle={closeModal}>
        <span>R365 upload</span>
      </ModalHeader>
      <ModalBody>
        <span>Please upload the "R365 Upload Format" file downloaded from R365.</span>
        <FormGroup className="mb-0">
          <Label className="mr-1 mb-0 " for="exampleFile">
            Select file
          </Label>
          <Input type="file" name="to_update" id="to_update" accept=".xls" onChange={handleChangeFile} />
        </FormGroup>
      </ModalBody>
      <ModalFooter>
        <Button color="primary" disabled={!file} onClick={() => onJoinedExport({ file })}>
          Generate
        </Button>
        <Button color="secondary" onClick={closeModal}>
          Cancel
        </Button>
      </ModalFooter>
    </Modal>
  );
};

ModalUploadR365File.propTypes = {
  onSubmit: PropTypes.func,
  vendors: PropTypes.array,
  closeModal: PropTypes.func,
  isModalOpen: PropTypes.func,
};

export default ModalUploadR365File;
